export function buildDatabaseSchema(...keys) {
    return keys.join(', ');
}
//# sourceMappingURL=database-schema-builder.js.map